module.exports = __webpack_public_path__ + "static/media/SHOPLINE.02594650.png";